import { Component, Injector, OnInit } from '@angular/core';
import { AppConfiguration } from 'src/app/app-configuration';
import { ARTIFACT_KEY } from 'src/app/core/constants/artifacts-order.constants';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { UploadService } from 'src/app/core/services/upload.service';
import { from, mergeMap } from 'rxjs';
import { ARTIFACT_SUBMMITED_BY } from 'src/app/core/enums/artifact.enum';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.scss']
})
export class TranscriptComponent extends ArtifactBaseComponent implements OnInit {

  ARTIFACT_KEY = ARTIFACT_KEY;
  documents:any[] = [];
  constructor(
    private injector: Injector,
    public appConfig: AppConfiguration,
    public override appWizService : AppWizService,
    public override uploadService : UploadService,
  ) {
    super(injector)
  }

  initJsonData(){}
  validateJsonData(){}
  resetJsonData(){
    this.artifact.isArtifactUpdated = true;
    this.artifact.sectionValid = false;
  }

  override processBeforeSubmit(){
    this.jsonData = {sectionValid:this.artifact.sectionValid};
  }

  TranscriptArtifactChecked(){
    this.artifact.isArtifactUpdated = true;
    this.validateSection();
  }
}
